import React from 'react'
import { useTranslation } from 'react-i18next'

import EntityAddEditForm from 'js/components/EntityActions/EntityAddEditForm'

const Create = ({ name, subtype }) => {
    const { t } = useTranslation()

    return (
        <EntityAddEditForm
            title={t('custom-content-type.create-item', { name })}
            subtype={subtype}
            {...({} as any)}
        />
    )
}

export default Create
